import React, { FunctionComponent, MouseEventHandler } from 'react';

import './transparent-button.scss';

interface ITransparentButton {
  customClasses? : string;
  disabled? : boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  name?: string;
}

const TransparentButton: FunctionComponent<ITransparentButton> = ({ children, customClasses, disabled, ...props }): JSX.Element => (
  <button className={`transparent-button ${customClasses ? customClasses : ''}`} disabled={disabled || false} {...props}>
    {children}
  </button>
);

export default TransparentButton;
